import { render, staticRenderFns } from "./ShoeArea.vue?vue&type=template&id=1db08a58&"
import script from "./ShoeArea.vue?vue&type=script&lang=js&"
export * from "./ShoeArea.vue?vue&type=script&lang=js&"
import style0 from "./ShoeArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports